<template>
<div class="gi-title" :class="{'is-light': theme==='light'}">
  <h1 v-if="data.h1"><span>{{data.h1}}</span></h1>
  <h2 v-if="data.h2">{{data.h2}}</h2>
</div>
</template>

<script>
export default {
  props: ['data', 'theme']
}
</script>

<style lang="sass">

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.gi-title
  text-align: center
  color: #000
  margin-bottom: 50px
  h1
    font-size: 36px
    color: #000
    span
      display: inline-block
      position: relative
      &:before
        content: ''
        width: 21px
        height: 6px
        background: url('./assets/left.png') no-repeat
        background-size: 21px 6px
        background-position: center center
        position: absolute
        left: -50px
        top: 24px
        +mobile
          top: 14px
          left: -35px
      &:after
        content: ''
        width: 21px
        height: 6px
        background: url('./assets/right.png') no-repeat
        background-size: 21px 6px
        background-position: center center
        position: absolute
        right: -50px
        top: 24px
        +mobile
          top: 14px
          right: -35px
  h2
    font-size: 16px
    color: #000
  +mobile
    margin-bottom: 20px
    h1
      font-size: 22px
    h2
      font-size: 16px
  &.is-light
    color: #fff
    h2
      color: #5d5d5d
</style>
